/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./permission.defs.js";
export { main as default } from "./permission.defs.js";
